import React, { useState, useEffect } from "react";
import { Container, HeaderContainer } from "./styles";
import { Table, Button, Space, Tooltip, Tag, Modal, Avatar } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../hooks/LanguageContext";
import api from "../../services/api";
import { returnCatch } from "../../services/functions";

const { confirm } = Modal;

export default function Nutritions() {
  const [nutritions, setNutritions] = useState([]);
  const [nutritionsTotal, setNutritionsTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { language } = useLanguage();

  useEffect(() => {
    loadingScreen();
  }, [page, language]);

  async function loadingScreen() {
    setLoading(true);
    await api
      .get(`/admin/nutritions?language=${language}&page=${page}`)
      .then((response) => {
        setNutritions(response.data.nutritions);
        setNutritionsTotal(response.data.nutritionsTotal);
      })
      .catch(({ response }) => {
        returnCatch(response);
      });
    setLoading(false);
  }

  const columns = [
    {
      title: "Capa",
      dataIndex: "photo_url",
      key: "photo_url",
      width: 90,
      render: (photo) => <Avatar src={photo} size={70} shape="square" />,
    },
    {
      title: "Título",
      dataIndex: "title",
      key: "title",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Fase",
      dataIndex: "phase",
      key: "phase",
      render: (phase) => {
        let color = "geekblue";
        if (phase === "MENSTRUAL") color = "red";
        if (phase === "OVULATORIA") color = "purple";
        if (phase === "LUTEA") color = "gold";
        return <Tag color={color}>{phase}</Tag>;
      },
    },
    {
      title: "Conteudos",
      dataIndex: "contents",
      key: "contents",
      render: (contents) => {
        const count = contents?.length || 0;

        const label = count === 1 ? "Bloco" : "Blocos";

        return (
          <strong>
            {count} {label}
          </strong>
        );
      },
    },
    {
      title: "Ações",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="Editar">
            <Button
              icon={<EditOutlined />}
              onClick={() => navigate(`/nutritions/edit/${record.id}`)}
              type="primary"
              ghost
              shape="circle"
            />
          </Tooltip>
          <Tooltip title="Excluir">
            <Button
              icon={<DeleteOutlined />}
              onClick={() => handleDelete(record)}
              danger
              shape="circle"
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  async function deleteNutrition(id) {
    await api
      .delete(`/admin/nutrition/${id}`)
      .then(() => {
        loadingScreen();
        toast.success("Receita excluída com sucesso");
      })
      .catch(({ response }) => {
        returnCatch(response);
      });
  }

  const handleDelete = (item) => {
    confirm({
      title: "Excluir Receita?",
      icon: <ExclamationCircleOutlined />,
      content: `A receita "${item.title}" será removida.`,
      okText: "Sim, Excluir",
      okType: "danger",
      cancelText: "Cancelar",
      onOk() {
        deleteNutrition(item.id);
      },
    });
  };

  return (
    <Container>
      <HeaderContainer>
        <h1>{nutritionsTotal} Receitas</h1>
        <div className="actions-container">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => navigate("/nutritions/new")}
            size="large"
          >
            Nova Receita
          </Button>
        </div>
      </HeaderContainer>

      <Table
        columns={columns}
        dataSource={nutritions}
        loading={loading}
        pagination={{ position: ["bottomCenter"], pageSize: 10 }}
        rowKey="id"
      />
    </Container>
  );
}
